module.exports = __webpack_public_path__ + "static/img/bg_xiazai_bang_2.2af261b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_xiazai_bang_2.png
// module id = WxF7
// module chunks = 0